module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-11b54e5c.svg";